import React, { memo } from 'react'
import { advertiserFinanceMenu, publisherDefaultFinanceMenu, publisherHTRFinanceMenu } from '../../data/Menu'
import PopulateMenu from './PopulateMenu'

const FinancesMenu = ({ advertiserId, publisherId, hasAccess, toggleMenu, onUpdateSize, menuName, language }) => {
    const appvizer_pub_id = 73
    const nnx_pub_id = 34
    const isHTR = [67, 10].includes(publisherId)
    const isAdvSession = advertiserId && hasAccess('finance_access')
    let menuToRender = []
    if (advertiserId && (publisherId === appvizer_pub_id || publisherId === nnx_pub_id)) {
        return null
    }
    if (isAdvSession) {
        menuToRender = advertiserFinanceMenu
        if (advertiserId && (publisherId === appvizer_pub_id || publisherId === nnx_pub_id || isHTR)) {
            return null
        }
    } else if (isHTR) {
        menuToRender = publisherHTRFinanceMenu
    } else {
        menuToRender = publisherDefaultFinanceMenu
        if (publisherId === appvizer_pub_id) {
            menuToRender = publisherDefaultFinanceMenu.filter(item => item.label.EN === 'Transactions')
        }
    }

    return (
        <div className="nav-group show">
            <div className="nav-label" onClick={toggleMenu}>
                {menuName}
            </div>
            <PopulateMenu menuItems={menuToRender} advertiserId={advertiserId} onUpdateSize={onUpdateSize} language={language} />
        </div>
    )
}

export default memo(FinancesMenu)
